module.exports = __webpack_public_path__ + "img/data-title-small.90cbcf4a.png";